import { useState } from 'react';
import { Box, Chip, IconButton, Paper, Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { suggestionPanelStyles } from './screenDriftStyles';

export default function SuggestionPanel({ suggestions }) {
  const [copiedKey, setCopiedKey] = useState(null);

  const handleCopy = async (value, key) => {
    await navigator.clipboard.writeText(value);
    setCopiedKey(key);
    setTimeout(() => setCopiedKey(null), 1200);
  };

  return (
    <Paper variant="outlined" sx={suggestionPanelStyles.root}>
      <Typography variant="subtitle2" fontWeight={800} sx={suggestionPanelStyles.title}>
        Self-Locator Discovery
      </Typography>
      <Stack spacing={1.5}>
        {suggestions.map((suggestion, suggestionIndex) => {
          const confidence = (suggestion.confidence || 'LOW').toLowerCase();
          const percentage = Math.round((suggestion.score || 0) * 100);
          return (
            <Paper key={suggestionIndex} variant="outlined" sx={suggestionPanelStyles.card}>
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={suggestionPanelStyles.header}
              >
                <Chip
                  size="small"
                  color={
                    confidence === 'high'
                      ? 'success'
                      : confidence === 'medium'
                        ? 'warning'
                        : 'default'
                  }
                  label={(suggestion.confidence || 'LOW').toUpperCase()}
                />
                <Typography variant="body2" fontWeight={700}>
                  {percentage}% match
                </Typography>
              </Stack>
              <Typography variant="caption" color="text.secondary">
                {(suggestion.match_reasons || []).join(', ')}
              </Typography>
              <Stack spacing={0.75} sx={suggestionPanelStyles.alternatives}>
                {(suggestion.alternatives || []).map((alternative, alternativeIndex) => {
                  const key = `${suggestionIndex}-${alternativeIndex}`;
                  return (
                    <Box key={key} sx={suggestionPanelStyles.alternativeRow}>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={suggestionPanelStyles.strategy}
                      >
                        {alternative.strategy}
                      </Typography>
                      <Typography variant="caption" sx={suggestionPanelStyles.code}>
                        {alternative.code}
                      </Typography>
                      <IconButton size="small" onClick={() => handleCopy(alternative.code, key)}>
                        {copiedKey === key ? (
                          <CheckCircleIcon color="success" fontSize="small" />
                        ) : (
                          <ContentCopyIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Box>
                  );
                })}
              </Stack>
            </Paper>
          );
        })}
      </Stack>
    </Paper>
  );
}
